import React from 'react';
import { __ } from './translations';

interface ContributionFormProps {
    selectedYear: string | null;
    income: string;
    memberType: string;
    declaration?: boolean;
    availableYears: Array<{
        id: number;
        title: {
            rendered: string;
        };
    }>;
    onYearChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
    onIncomeChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onDeclarationChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
}

const ContributionForm = React.memo<ContributionFormProps>(({
    selectedYear,
    income,
    memberType,
    declaration = false,
    availableYears,
    onYearChange,
    onIncomeChange,
    onDeclarationChange,
    onSubmit,
}) => (
    <div className="contribution-form">
        <form onSubmit={onSubmit}>
            <div className="form-group mb-4">
                <label
                    className="block text-sm font-medium text-gray-700 mb-2"
                >
                    {__('Select a Year')}
                </label>
                <select
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    onChange={onYearChange}
                    value={selectedYear || ''}
                    required
                >
                    <option value="">{__('Select a Year')}</option>
                    {availableYears.map((year) => (
                        <option key={year.id} value={year.id}>
                            {year?.title?.rendered || ''}
                        </option>
                    ))}
                </select>
            </div>

            {memberType === 'regular' && (
                <div className="form-group mb-4">
                    <label
                        className="block text-sm font-medium text-gray-700 mb-2"
                    >
                        {__('Enter Last Year Income (PLN million)')}
                    </label>
                    <input
                        type="number"
                        placeholder={__('Enter Last Year Income (PLN million)')}
                        value={income}
                        className="mt-1 mb-6 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        onChange={onIncomeChange}
                        required
                        step="0.01"
                        min="0"
                    />
                </div>
            )}

            <div className="form-group mb-6">
                <label className="inline-flex items-start space-x-3">
                    <input
                        type="checkbox"
                        className="mt-1 form-checkbox h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                        checked={declaration}
                        onChange={onDeclarationChange}
                        required
                    />
                    <span className="ml-2 text-sm text-gray-700">
                        {__('I declare that the financial data provided by me are consistent with the actual state and I bear full responsibility for them')}
                    </span>
                </label>
            </div>

            <button
                type="submit"
                className="mt-4 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800 disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={!declaration || !selectedYear || (memberType === 'regular' && !income)}
            >
                {__('Calculate Contribution')}
            </button>
        </form>
    </div>
));

ContributionForm.displayName = 'ContributionForm';

export default ContributionForm;